import * as tslib_1 from "tslib";
import { getPremiumUser } from '../services/getPremiumUser';
import { orchestrator } from 'satcheljs';
import setPremiumUserState from '../mutators/setPremiumUserState';
import { getPremiumUser as getPremiumUserAction } from '../actions/getPremiumUser';
export default orchestrator(getPremiumUserAction, function getPremiumUserAction() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getPremiumUser()];
                case 1:
                    response = _a.sent();
                    setPremiumUserState(response);
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=getPremiumUser.js.map